/* ==========================================================================
   AZURE GLASSES — theme behaviour v30
   No libraries, no frameworks, no dependencies.
   ========================================================================== */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MOBILE = '(max-width: 900px)';

  /* Etiqueta de envío del drawer.
     Pónla en 'GRATIS' SOLO si el envío es realmente gratuito para todos los
     pedidos y todas las zonas. Si depende del importe o del destino, usa
     'Calculado en el checkout': anunciar un envío gratis que luego se cobra
     es publicidad engañosa. */
  var SHIPPING_LABEL = 'GRATIS';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function money(cents) {
    return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
  }

  /* ------------------------------------------------------------------------
     Header — solid state + hide on scroll down, reveal on scroll up
     ------------------------------------------------------------------------ */

  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;

    var lastY = window.scrollY;
    var ticking = false;

    function update() {
      var y = window.scrollY;

      // Pins the header and, on the homepage, swaps it from transparent to solid
      header.classList.toggle('is-solid', y > 40);

      // Only auto-hide once well past the fold, and never while a panel is open
      var locked = document.body.classList.contains('is-locked');
      if (!locked && y > 400) {
        header.classList.toggle('is-hidden', y > lastY + 4);
      } else {
        header.classList.remove('is-hidden');
      }

      lastY = y;
      ticking = false;
    }

    update();
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
  }

  /* ------------------------------------------------------------------------
     Reveal on scroll
     ------------------------------------------------------------------------ */

  function initReveal() {
    var els = $$('.reveal, .reveal-img, .review-bars');
    if (!els.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------------
     Scroll lock (shared by menu + cart drawer)
     ------------------------------------------------------------------------ */

  var scrollLockY = 0;

  function lockScroll() {
    if (document.body.classList.contains('is-locked')) return;
    scrollLockY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = -scrollLockY + 'px';
    document.body.style.width = '100%';
    document.body.classList.add('is-locked');
  }

  function unlockScroll() {
    if (!document.body.classList.contains('is-locked')) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.classList.remove('is-locked');
    window.scrollTo(0, scrollLockY);
  }

  /* Keep focus inside an open panel */
  function trapFocus(container, event) {
    var focusables = $$(
      'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])',
      container
    ).filter(function (el) { return el.offsetParent !== null; });
    if (!focusables.length) return;

    var first = focusables[0];
    var last = focusables[focusables.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus();
    }
  }

  /* ------------------------------------------------------------------------
     Fullscreen menu
     ------------------------------------------------------------------------ */

  var menu, menuToggle, menuLastFocus;

  function openMenu() {
    if (!menu) return;
    menuLastFocus = document.activeElement;
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    lockScroll();
    var close = $('[data-menu-close]', menu);
    if (close) close.focus();
  }

  function closeMenu() {
    if (!menu || !menu.classList.contains('is-open')) return;
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    unlockScroll();
    if (menuLastFocus) menuLastFocus.focus();
  }

  function initMenu() {
    menu = $('[data-menu-overlay]');
    menuToggle = $('[data-menu-open]');
    if (!menu) return;

    $$('[data-menu-open]').forEach(function (el) { el.addEventListener('click', openMenu); });
    $$('[data-menu-close]').forEach(function (el) { el.addEventListener('click', closeMenu); });
    $$('a', menu).forEach(function (a) { a.addEventListener('click', closeMenu); });

    menu.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') trapFocus(menu, e);
    });
  }

  /* ------------------------------------------------------------------------
     Cart drawer
     ------------------------------------------------------------------------ */

  var drawer, backdrop, drawerBody, drawerFooter, cartLastFocus;

  function bumpCartCount() {
    $$('[data-cart-count], .cart-count').forEach(function (el) {
      el.classList.add('is-bump');
      setTimeout(function () { el.classList.remove('is-bump'); }, 320);
    });
  }

  function setCartCount(count) {
    $$('[data-cart-count], .cart-count').forEach(function (el) { el.textContent = count; });
  }

  /* Catálogo serializado en el layout. Se lee una vez y se cachea. */
  var _catalog = null;
  function catalog() {
    if (_catalog) return _catalog;
    _catalog = [];
    var node = $('[data-azure-catalog]');
    if (node) {
      try { _catalog = JSON.parse(node.textContent) || []; } catch (e) { _catalog = []; }
    }
    return _catalog;
  }

  /* Sugerencias para completar el 2x1: modelos que aún no están en el carrito.
     Sin ellas el cliente tendría que salir del drawer, volver a la colección y
     encontrar una segunda gafa por su cuenta — el punto exacto donde se cae la
     conversión en una oferta de este tipo. */
  function crossSell(cart) {
    var items = catalog();
    if (!items.length) return '';

    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.variant_id] = true; });

    var picks = items.filter(function (p) { return !inCart[p.id]; }).slice(0, 6);
    if (!picks.length) return '';

    return '' +
      '<div class="drawer-xsell">' +
        '<span class="eyebrow">Elige tu segunda gafa gratis</span>' +
        '<div class="drawer-xsell__track">' +
          picks.map(function (p) {
            return '' +
              '<article class="xsell-card">' +
                '<a href="' + p.url + '" tabindex="-1" aria-hidden="true">' +
                  (p.image ? '<img src="' + p.image + '" alt="" loading="lazy" decoding="async">' : '<span class="xsell-ph"></span>') +
                '</a>' +
                '<a class="xsell-name" href="' + p.url + '">' + p.title + '</a>' +
                '<button type="button" class="xsell-add" data-xsell-add="' + p.id + '" ' +
                        'aria-label="Añadir ' + p.title + ' al carrito">Añadir</button>' +
              '</article>';
          }).join('') +
        '</div>' +
      '</div>';
  }

  function renderDrawer(cart) {
    if (!drawerBody || !drawerFooter) return;

    if (!cart.item_count) {
      drawerBody.innerHTML =
        '<div class="drawer-empty">' +
          '<span class="eyebrow">Tu selección está vacía</span>' +
          '<h3>Entra en el Club.</h3>' +
          '<a class="btn btn--navy" href="/collections/all">Descubrir novedades</a>' +
        '</div>';
      drawerBody.dataset.ready = '1';
      drawerFooter.hidden = true;
      drawerFooter.innerHTML = '';
      return;
    }

    drawerBody.dataset.ready = '1';
    drawerBody.innerHTML = cart.items.map(function (item, i) {
      var line = i + 1;
      return '' +
        '<div class="drawer-line" style="animation-delay:' + (i * 45) + 'ms">' +
          '<img src="' + (item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '') + '" alt="" loading="lazy">' +
          '<div>' +
            '<a class="drawer-title" href="' + item.url + '">' + item.product_title + '</a>' +
            (item.variant_title ? '<div class="drawer-line-variant">' + item.variant_title + '</div>' : '') +
            '<div class="drawer-qty">' +
              '<button type="button" data-line="' + line + '" data-qty="' + (item.quantity - 1) + '" aria-label="Reducir cantidad">-</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-line="' + line + '" data-qty="' + (item.quantity + 1) + '" aria-label="Aumentar cantidad">+</button>' +
            '</div>' +
            '<button type="button" class="drawer-remove" data-line="' + line + '" data-qty="0">Eliminar</button>' +
          '</div>' +
          '<strong>' + money(item.final_line_price) + '</strong>' +
        '</div>';
    }).join('');

    drawerFooter.hidden = false;
    drawerFooter.innerHTML =
      '<div class="drawer-total"><span>Subtotal</span><strong>' + money(cart.total_price) + '</strong></div>' +
      '<a class="btn btn--navy" href="/checkout">Continuar</a>' +
      '<p class="drawer-trust">Pago seguro · Envío desde España · Devoluciones en 14 días</p>';

    $$('[data-xsell-add]', drawer).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Añadiendo…';

        var secondVariant = Number(btn.dataset.xsellAdd);

        /*
          IMPORTANTE 2x1:
          Cuando el carrito contiene exactamente una gafa, no añadimos la segunda
          como una petición aislada. Algunas lógicas de bundle/descuento de Shopify
          y apps de promociones solo reconocen el pack cuando los dos artículos
          entran juntos en la misma operación de add.

          Rehacemos ese único artículo como un pack de 2 en una sola llamada:
          1) quitamos temporalmente la primera línea;
          2) añadimos primera + segunda juntas.

          Así nunca se crean 3 unidades y el 2x1 recibe exactamente el mismo patrón
          que el selector de pack de la ficha de producto.
        */
        var singleItemPack = cart.item_count === 1 && cart.items.length === 1 && cart.items[0].quantity === 1;
        var request;

        if (singleItemPack) {
          var firstVariant = Number(cart.items[0].variant_id);
          request = fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: 1, quantity: 0 })
          }).then(function (r) {
            if (!r.ok) throw new Error('remove failed');
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [
                  { id: firstVariant, quantity: 1 },
                  { id: secondVariant, quantity: 1 }
                ]
              })
            });
          });
        } else {
          request = fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: secondVariant, quantity: 1 }] })
          });
        }

        request
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return refreshCart();
          })
          .then(function () {
            bumpCartCount();
            document.dispatchEvent(new CustomEvent('azure:cart:updated'));
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = original;
          });
      });
    });

    $$('[data-line]', drawer).forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(Number(btn.dataset.line), Math.max(0, Number(btn.dataset.qty)));
      });
    });
  }

  /* Images fade in as they decode instead of snapping into place. Applied from
     JS so no Liquid template needs touching, with a timeout so an image that
     never fires `load` can never stay invisible. */
  function initImageFade() {
    if (reduceMotion) return;

    $$('img[loading="lazy"]').forEach(function (img) {
      if (img.closest('.hero')) return;

      if (img.complete && img.naturalWidth) return;

      img.setAttribute('data-fade', '');
      var reveal = function () { img.classList.add('is-loaded'); };

      img.addEventListener('load', reveal, { once: true });
      img.addEventListener('error', reveal, { once: true });
      setTimeout(reveal, 3000);
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function refreshCart() {
    return fetchCart().then(function (cart) {
      setCartCount(cart.item_count);
      renderDrawer(cart);
      return cart;
    });
  }

  function changeLine(line, quantity) {
    if (drawerBody) drawerBody.style.opacity = '.5';
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(refreshCart)
      .finally(function () { if (drawerBody) drawerBody.style.opacity = ''; });
  }

  function openCart() {
    if (!drawer || !backdrop) return;
    cartLastFocus = document.activeElement;
    backdrop.hidden = false;
    // Force reflow so the opacity transition runs
    void backdrop.offsetWidth;
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockScroll();
    if (drawerBody && !drawerBody.dataset.ready) {
      drawerBody.innerHTML = '<div class="drawer-skeleton"><span></span><span></span></div>';
    }
    refreshCart();
    var close = $('[data-cart-close]', drawer);
    if (close) close.focus();
  }

  function closeCart() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    unlockScroll();
    setTimeout(function () { if (backdrop) backdrop.hidden = true; }, 420);
    if (cartLastFocus) cartLastFocus.focus();
  }

  function initCartDrawer() {
    drawer = $('.cart-drawer');
    backdrop = $('.cart-drawer-backdrop');
    drawerBody = $('[data-cart-body]');
    drawerFooter = $('[data-cart-footer]');

    $$('[data-cart-open]').forEach(function (el) { el.addEventListener('click', openCart); });
    $$('[data-cart-close]').forEach(function (el) { el.addEventListener('click', closeCart); });

    if (drawer) {
      drawer.addEventListener('keydown', function (e) {
        if (e.key === 'Tab') trapFocus(drawer, e);
      });
    }
  }

  /* ------------------------------------------------------------------------
     Add to cart — quick add + product form
     ------------------------------------------------------------------------ */

  function flashButton(btn, html, ms) {
    var original = btn.innerHTML;
    btn.innerHTML = html;
    btn.disabled = true;
    setTimeout(function () {
      btn.innerHTML = original;
      btn.disabled = false;
      btn.classList.remove('is-added');
    }, ms || 1500);
  }

  function initQuickAdd() {
    $$('[data-quick-add]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = $('button', form);
        if (!btn || btn.disabled) return;
        var original = btn.innerHTML;

        btn.disabled = true;
        btn.innerHTML = 'Añadiendo…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(form.dataset.variant), quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            btn.innerHTML = 'Añadido';
            btn.classList.add('is-added');
            bumpCartCount();
            openCart();
          })
          .catch(function () { btn.innerHTML = 'Inténtalo de nuevo'; })
          .finally(function () {
            setTimeout(function () {
              btn.innerHTML = original;
              btn.disabled = false;
              btn.classList.remove('is-added');
            }, 1500);
          });
      });
    });
  }

  function initProductForm() {
    var form = $('.product-form-clean');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      // El selector de packs (azure-pdp.js) gestiona el envío entero cuando el
      // tramo elegido tiene más de 1 unidad: añade el producto base + cada
      // pieza elegida en una sola llamada a /cart/add.js. Si este manejador
      // TAMBIÉN interceptara ese mismo envío (los dos escuchan el mismo
      // 'submit'), el producto base se añadía una segunda vez de más: el bug
      // reportado como "se añade 2 veces el primer producto". Nos apartamos
      // por completo en cuanto detectamos un tramo de pack con qty > 1.
      var packSelector = $('[data-pack-selector]');
      if (packSelector) {
        var selectedOpt = $('[data-pack-option].is-selected', packSelector);
        var packQty = selectedOpt ? Number(selectedOpt.dataset.qty) : 1;
        if (packQty > 1) return;
      }

      e.preventDefault();
      var btn = $('[type="submit"]', form);
      if (!btn || btn.disabled) return;
      var original = btn.innerHTML;

      btn.disabled = true;
      btn.innerHTML = '<span>Añadiendo…</span>';

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          btn.innerHTML = '<span>Añadido al carrito</span>';
          btn.classList.add('is-added');
          bumpCartCount();
          openCart();
          setTimeout(function () {
            btn.innerHTML = original;
            btn.disabled = false;
            btn.classList.remove('is-added');
          }, 1600);
        })
        .catch(function () {
          // Fall back to a normal form post so the customer is never stuck
          btn.disabled = false;
          btn.innerHTML = original;
          form.submit();
        });
    });

    // Sticky mobile bar reuses the same form
    var stickyBtn = $('[data-sticky-add-button]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }
  }

  /* Variant select — keep every price on the page in sync */
  function initVariantSelect() {
    var select = $('[data-variant-select]');
    if (!select) return;

    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      var price = opt && opt.dataset.price;
      if (!price) return;
      $$('[data-price], [data-button-price], [data-sticky-price]').forEach(function (el) {
        el.textContent = price;
      });
    });
  }

  /* ------------------------------------------------------------------------
     Product gallery
     ------------------------------------------------------------------------ */

  function initGallery() {
    $$('[data-product-gallery]').forEach(function (gallery) {
      var track = $('[data-gallery-track]', gallery);
      var slides = $$('[data-gallery-slide]', gallery);
      var thumbs = $$('[data-gallery-thumb]', gallery);
      var counter = $('[data-gallery-current]', gallery);
      var prev = $('[data-gallery-prev]', gallery);
      var next = $('[data-gallery-next]', gallery);
      if (!track || slides.length < 2) return;

      var index = 0;

      function setActive(i) {
        index = Math.max(0, Math.min(i, slides.length - 1));
        slides.forEach(function (s, n) {
          var active = n === index;
          s.classList.toggle('is-active', active);
          var video = $('video', s);
          if (video) {
            if (active) {
              video.muted = true;
              var playPromise = video.play();
              if (playPromise && playPromise.catch) playPromise.catch(function () {});
            } else {
              video.pause();
            }
          }
        });
        thumbs.forEach(function (t, n) {
          var on = n === index;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        if (counter) counter.textContent = index + 1;
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === slides.length - 1;
      }

      function goTo(i) {
        i = Math.max(0, Math.min(i, slides.length - 1));
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        setActive(i);
        if (thumbs[i]) thumbs[i].scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () { goTo(Number(thumb.dataset.index)); });
      });
      if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
      });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          setActive(Math.round(track.scrollLeft / track.clientWidth));
          ticking = false;
        });
      }, { passive: true });

      setActive(0);
    });
  }

  /* ------------------------------------------------------------------------
     Sticky mobile add-to-cart — resize safe
     ------------------------------------------------------------------------ */

  function initStickyAdd() {
    var bar = $('[data-sticky-add]');
    var anchor = $('.add-button');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    // La barra funciona en todos los tamaños: en escritorio el botón de
    // compra también queda por debajo del pliegue.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });

    io.observe(anchor);
  }

  /* ------------------------------------------------------------------------
     Dispatch cutoff — a real, recurring operational fact, not a fake timer
     ------------------------------------------------------------------------ */

  function initShippingCutoff() {
    var wrap = $('[data-shipping-cutoff]');
    var text = $('[data-shipping-text]');
    if (!wrap || !text) return;

    var CUTOFF_HOUR = 14;
    var parts;

    try {
      parts = new Intl.DateTimeFormat('es-ES', {
        timeZone: 'Europe/Madrid', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false
      }).formatToParts(new Date());
    } catch (err) {
      return; // Never show a shipping promise we cannot compute
    }

    function part(type) {
      var found = parts.find(function (p) { return p.type === type; });
      return found ? found.value : '';
    }

    var hour = parseInt(part('hour'), 10);
    var minute = parseInt(part('minute'), 10);
    var weekday = part('weekday').toLowerCase().slice(0, 3);
    var isWeekend = weekday.indexOf('sá') === 0 || weekday.indexOf('sab') === 0 || weekday.indexOf('dom') === 0;
    var isFriday = weekday.indexOf('vie') === 0;

    var message;

    if (isWeekend) {
      message = 'Los pedidos de este fin de semana <b>salen el lunes</b> desde España.';
    } else if (hour < CUTOFF_HOUR) {
      var hoursLeft = CUTOFF_HOUR - hour - (minute > 0 ? 1 : 0);
      var minsLeft = minute > 0 ? 60 - minute : 0;
      var left = hoursLeft > 0 ? hoursLeft + ' h ' + minsLeft + ' min' : minsLeft + ' min';
      message = 'Pídelo en las próximas <b>' + left + '</b> y sale hoy mismo desde España.';
    } else if (isFriday) {
      message = 'Los pedidos de hoy después de las 14:00 <b>salen el lunes</b> desde España.';
    } else {
      message = 'Los pedidos realizados ahora <b>salen mañana</b> desde España.';
    }

    text.innerHTML = message;
    wrap.hidden = false;
  }

  /* ------------------------------------------------------------------------
     Cart page quantity controls
     ------------------------------------------------------------------------ */

  function updateCartPageLine(button, delta) {
    var line = button.closest('.cart-line');
    var input = $('input', button.parentElement);
    if (!line || !input) return;

    var newQty = Math.max(0, Number(input.value) + delta);
    input.value = newQty;

    var key = line.dataset.lineKey;
    if (!key) return;

    var priceEl = $('.cart-line-price', line);
    if (priceEl) priceEl.style.opacity = '.4';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
      .then(function () { return fetchCart(); })
      .then(function (cart) {
        setCartCount(cart.item_count);

        if (newQty === 0) { window.location.reload(); return; }

        var item = cart.items.find(function (i) { return i.key === key; });
        if (item && priceEl) {
          priceEl.textContent = money(item.final_line_price);
          priceEl.style.opacity = '1';
        }

        var totalEl = $('.cart-total strong');
        if (totalEl) totalEl.textContent = money(cart.total_price);

        var qty = cart.item_count;
        var pairs = Math.floor(qty / 2);
        var odd = qty % 2 === 1;
        var complete = pairs >= 1 && !odd;

        var box = $('.cart-bogo');
        var heading = $('.cart-bogo h2');
        var copy = $('.cart-bogo p');
        var meter = $('.pack-meter span');
        var meterLabel = $('.pack-meter-label');
        var pickCta = $('.cart-bogo .btn--outline');

        if (box) box.classList.toggle('is-unlocked', complete);

        if (heading) {
          heading.textContent = pairs < 1
            ? 'Te falta una gafa'
            : pairs + (pairs === 1 ? ' gafa gratis' : ' gafas gratis');
        }
        if (copy) {
          copy.textContent = complete
            ? 'El descuento se aplica automáticamente al finalizar la compra.'
            : 'Añade cualquier otro modelo y la siguiente te sale gratis.';
        }
        if (meter) meter.style.width = complete ? '100%' : '50%';
        if (meterLabel) meterLabel.textContent = qty + (qty === 1 ? ' gafa en el carrito' : ' gafas en el carrito');
        if (pickCta) pickCta.hidden = complete;
      });
  }

  function initCartPage() {
    $$('[data-cart-page-decrease]').forEach(function (b) {
      b.addEventListener('click', function () { updateCartPageLine(b, -1); });
    });
    $$('[data-cart-page-increase]').forEach(function (b) {
      b.addEventListener('click', function () { updateCartPageLine(b, 1); });
    });
  }

  /* ------------------------------------------------------------------------
     Boot
     ------------------------------------------------------------------------ */

  function init() {
    initHeader();
    initReveal();
    initMenu();
    initCartDrawer();
    initQuickAdd();
    initProductForm();
    initVariantSelect();
    initGallery();
    initStickyAdd();
    initShippingCutoff();
    initCartPage();
    initImageFade();

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeMenu(); closeCart(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* ==========================================================================
   Cuentas atrás — barra de anuncio y hero. Todas comparten el mismo
   vencimiento cuando usan el mismo modo, para que nunca marquen distinto.
   ========================================================================== */

(function () {
  'use strict';

  var nodes = document.querySelectorAll('[data-countdown]');
  if (!nodes.length) return;

  var KEY = 'azure_promo_deadline';

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function midnight() {
    var d = new Date();
    d.setHours(23, 59, 59, 999);
    return d.getTime();
  }

  function target(el) {
    var mode = el.dataset.mode || 'midnight';

    if (mode === 'fixed') {
      var t = Date.parse(el.dataset.deadline);
      return isNaN(t) ? midnight() : t;
    }

    if (mode === 'rolling') {
      var stored;
      try { stored = Number(window.localStorage.getItem(KEY)); } catch (e) { stored = 0; }
      if (stored && stored > Date.now()) return stored;
      var fresh = Date.now() + (Number(el.dataset.hours || 24) * 3600 * 1000);
      try { window.localStorage.setItem(KEY, String(fresh)); } catch (e) {}
      return fresh;
    }

    return midnight();
  }

  var clocks = [];

  Array.prototype.forEach.call(nodes, function (el) {
    var h = el.querySelector('[data-cd="h"]');
    var m = el.querySelector('[data-cd="m"]');
    var s = el.querySelector('[data-cd="s"]');
    if (!h || !m || !s) return;

    clocks.push({
      el: el,
      h: h, m: m, s: s,
      mode: el.dataset.mode || 'midnight',
      end: target(el),
      done: false
    });
  });

  if (!clocks.length) return;

  function tick() {
    var alive = 0;

    clocks.forEach(function (c) {
      if (c.done) return;

      var left = c.end - Date.now();

      if (left <= 0) {
        if (c.mode === 'midnight') { c.end = midnight(); alive++; return; }
        c.el.hidden = true;
        c.done = true;
        return;
      }

      var total = Math.floor(left / 1000);
      c.h.textContent = pad(Math.floor(total / 3600));
      c.m.textContent = pad(Math.floor((total % 3600) / 60));
      c.s.textContent = pad(total % 60);
      alive++;
    });

    if (!alive) clearInterval(timer);
  }

  tick();
  var timer = setInterval(tick, 1000);
})();
